import { useGetMadinaManifestPilgrimsQuery, useGetMadinaTafweejPilgrimsQuery } from "@/services/arrivals/madinah/arrival.madinah";
import { useSearchQuery } from "@/utils/hooks/useSearchQuery";

export const useViewPilgrims = ({ filters, page, pageSize, manifestId }) => {
    const [query] = useSearchQuery();
    const isFromPorts = query?.source === "from_ports"
    const isBetweenCities = query?.source === "between_cities"

    const { data: pilgrimsRes, isLoading: isPilgrimsLoading } = useGetMadinaManifestPilgrimsQuery({
        ...filters,
        page,
        per_page: pageSize,
    },
        isFromPorts || !query?.source,
        manifestId
    );

    const { data: tafweejPilgrimsRes, isLoading: isTafweejPilgrimsLoading } = useGetMadinaTafweejPilgrimsQuery({
        ...filters,
        page,
        per_page: pageSize,
    },
        isBetweenCities,
        manifestId
    );


    const pilgrims = isBetweenCities ? tafweejPilgrimsRes?.data?.data : pilgrimsRes?.data?.data || [];
    const meta = isBetweenCities ? tafweejPilgrimsRes?.data?.meta : pilgrimsRes?.data?.meta || {};
    const loading = isPilgrimsLoading || isTafweejPilgrimsLoading;

    return {
        pilgrims,
        meta,
        loading,
    }
}